import { Button, Input, Typography, Alert } from '@material-tailwind/react'
import { useFormik } from 'formik'
import validationSchema from './utils/validation-schema-update'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useResetPasswordMutation } from '@/store/services'

export const RecoveryPasswordUpdate = (props) => {
  const navigate = useNavigate()
  const [recoveryPasswordError, setRecoveryPasswordError] = useState(null)
  const searchParams = new URLSearchParams(window.location.search)
  const resetPasswordToken = searchParams.get('reset_password_token')
  const [resetPassword] = useResetPasswordMutation()

  const handleRecoveryPasswordUpdate = async (values) => {
    try {
      const a = await resetPassword({
        user: {
          reset_password_token: resetPasswordToken,
          password: values.password,
          password_confirmation: values.confirmPassword
        }
      })
      console.log(a)
      navigate('/sign_in')
    } catch ({ response }) {
      setRecoveryPasswordError(response.data.error)
    }
  }

  const { handleBlur, handleSubmit, handleChange, values, errors, touched } =
    useFormik({
      initialValues: { password: '', confirmPassword: '' },
      validationSchema,
      onSubmit: handleRecoveryPasswordUpdate
    })

  return (
    <div className='w-full h-full max-w-lg p-4 flex items-center my-0 mx-auto flex-col justify-center gap-16'>
      <section className='flex gap-10 flex-col justify-center items-center'>
        <div className='grid gap-4'>
          <Typography variant='h4'>Ingresa la contraseña nueva</Typography>

          <Typography variant='h6' color='gray' className='font-normal'>
            Escribe y confirma tu nueva contraseña para la plataforma. La
            contraseña debe tener mínimo 6 caracteres.
          </Typography>
        </div>
      </section>
      <div className='w-full flex flex-col gap-10'>
        <form onSubmit={handleSubmit}>
          <section className='flex flex-col gap-6'>
            <div>
              <div className='relative w-full'>
                <Input
                  name='password'
                  label='Escribe tu nueva contraseña'
                  type='password'
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(touched.password && errors.password)}
                />
              </div>
              {touched.password && errors.password && (
                <Typography
                  variant='small'
                  color='red'
                  className='mt-2 flex items-center gap-1 font-normal'
                >
                  {errors.password}
                </Typography>
              )}
            </div>

            <div>
              <div className='relative w-full'>
                <Input
                  name='confirmPassword'
                  label='Repite tu nueva contraseña'
                  type='password'
                  value={values.confirmPassword}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(
                    touched.confirmPassword && errors.confirmPassword
                  )}
                />
              </div>
              {touched.confirmPassword && errors.confirmPassword && (
                <Typography
                  variant='small'
                  color='red'
                  className='mt-2 flex items-center gap-1 font-normal'
                >
                  {errors.confirmPassword}
                </Typography>
              )}
            </div>

            {recoveryPasswordError && (
              <Alert color='red' variant='outlined' className='bg-red-50'>
                {recoveryPasswordError}
              </Alert>
            )}

            <Button type='submit' size='lg'>
              Cambiar contraseña
            </Button>
          </section>
        </form>
      </div>
    </div>
  )
}
